const redirectPathMap = require('./redirectPathMap');

module.exports = {
    redirectPathMap
};
